<section class="modulos">
  <div class="modulos__container">
    <!-- Cabecera -->
    <header class="modulos__header">
      <p class="modulos__label">Módulos</p>
      <h1 class="modulos__title">Tu negocio, en un solo sitio</h1>
      <p class="modulos__intro">
        Empieza con el núcleo y activa solo los módulos que necesitas. Todos
        comparten los mismos datos: clientes, facturas, gastos, proyectos y
        equipo hablan entre sí.
      </p>
      <div class="modulos__header-cta">
        <p-button label="Ver precios" routerLink="/precios" size="large" />
        <p-button
          label="Soluciones por sector"
          routerLink="/soluciones"
          [outlined]="true"
          size="large" />
      </div>
      <p class="modulos__tax-note">Precios mensuales sin IVA.</p>
    </header>

    @if (isLoading) {
      <div class="modulos__state"><p>Cargando módulos…</p></div>
    } @else if (groups.length === 0) {
      <div class="modulos__state"><p>Próximamente</p></div>
    } @else {
      @for (group of groups; track group.category) {
        <div class="modulos__group">
          <h2 class="modulos__group-title">{{ group.category }}</h2>
          <div class="modulos__grid">
            @for (item of group.items; track item.cms_item_id) {
              <article class="modulos__card">
                @if (item.heroImage) {
                  <img
                    [src]="item.heroImage"
                    [alt]="item.title"
                    class="modulos__card-img"
                    loading="lazy" />
                }
                <div class="modulos__card-body">
                  <h3 class="modulos__card-title">{{ item.title }}</h3>
                  @if (item.subtitle) {
                    <p class="modulos__card-subtitle">{{ item.subtitle }}</p>
                  }
                  @if (item.description) {
                    <div
                      class="modulos__card-desc"
                      [innerHTML]="item.description"></div>
                  }
                  <div class="modulos__card-footer">
                    @if (item.price) {
                      <span class="modulos__card-price">
                        {{ item.price }} €
                        @if (item.priceUnit) {
                          <span class="modulos__card-unit">{{
                            item.priceUnit
                          }}</span>
                        }
                      </span>
                    } @else {
                      <span class="modulos__card-unit">Incluido</span>
                    }
                    <a class="modulos__card-link" routerLink="/contacto"
                      >Más info</a
                    >
                  </div>
                </div>
              </article>
            }
          </div>
        </div>
      }
    }

    <!-- A medida -->
    <div class="modulos__custom">
      <h2>¿Necesitas algo que no existe?</h2>
      <p>
        Lo desarrollamos a medida para centralizar tus procesos o lo que
        necesites.
      </p>
      <p-button label="Cuéntanos tu caso" routerLink="/contacto" size="large" />
    </div>
  </div>
</section>
